module.exports = __webpack_public_path__ + "img/yellow.1683665b.png";